<template>
  <div>
    <h3 class="mb-1">All News</h3>
    <news-cards-home :news="news" />
    <b-pagination
      v-model="currentPage"
      :total-rows="pagination.total"
      :per-page="perPage"
      first-number
      last-number
      class="mb-0 mt-1 mt-sm-0"
      prev-class="prev-item"
      next-class="next-item"
      @input="changePage"
    >
      <template #prev-text>
        <feather-icon icon="ChevronLeftIcon" size="18" />
      </template>
      <template #next-text>
        <feather-icon icon="ChevronRightIcon" size="18" />
      </template>
    </b-pagination>
  </div>
</template>

<script>
import NewsCardsHome from '@/views/user/home/news/NewsCardsHome.vue'
import { BPagination } from 'bootstrap-vue'

export default {
  components: {
    NewsCardsHome,
    BPagination,
  },

  data() {
    return {
      news: [],
      perPage: 8,
      currentPage: 1,
      pagination: {
        from: 1,
        to: 9,
        total: 0,
      },
    }
  },

  watch: {
    currentPage() {
      this.fetchNews()
    },
  },

  mounted() {
    this.fetchNews()
  },

  methods: {
    fetchNews() {
      this.$http
        .get('/browse-news', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.news = data.data
        })
    },
    changePage(page) {
      this.currentPage = page
    },
  },
}
</script>
